import {Component, OnInit, ViewChild} from '@angular/core';
import {LocalStorageService} from 'ng2-webstorage';
import {MessageService} from 'primeng/components/common/messageservice';
import {addUserFirebaseModel,addUserModel} from '../../../../../components/manageuser/adduser/adduser.model';
import {ActivatedRoute, Router} from '@angular/router';
import {AddUserService} from '../../../../../components/manageuser/adduser/adduser.service';
import {AddUserFirebaseService} from '../../../../../components/manageuser/adduser/adduserfirebase.service';
import {NoticeboardService} from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import {DepartmentService} from '../../../../../components/manageuser/department/department.service';
import {MenuItems} from '../../../../../shared/menu-items/menu-items';
import {SectionService} from '../../../../../components/manageuser/sections/sections.service';
import * as _ from 'lodash';


@Component({
  selector: 'app-student-profile',
  templateUrl: './manage-add-user.component.html',
  styleUrls: ['./manage-add-user.component.css']
})

export class ManageAddUserComponent implements OnInit {
  public gradeselectedsections: any;
  public mappedData: any;
  public department: any;
  public pagenum: number;
  public searchString: any;
  public sectionName: any;
  public sectionId: any;
  public activetab: number;
  public userId: any;
  public BranchId: any;
  public Code: any;
  public GenderId: any= null;
  public adduserModel = new addUserModel();
  public addUserFirebaseModel = new addUserFirebaseModel();
  public entireSchoolflag: boolean = false;
  public Es: boolean;
  public selectedPayload: any = [];
  public allMenu: any = [];
  public selectedClass = [];
  public selectedCategory = [];
  public selectedPermission = [];
  public categeories: any;
  public categeoriesList = [];
  //cut from main array for class teacher and grade head.
  public standards: any;
  public standards1: any = [];
  public schoolid: any;
  public selectedtab: number;
  public isDisabled: boolean = false;
  public show: boolean = false;
  public tabroleID: any;
  public sectionsData: any;
  public SectionData: any;
  public adminflag: boolean = false;
  public UserSpecializationCategoryId: any;
  public selectedTabId: any;
  public userdetailes: any;
  public islist: boolean = false;
  username: boolean = false;
  constructor(private router: Router,
              private SectionService: SectionService,
              private addUserService: AddUserService,
              private activateroute: ActivatedRoute,
              private messageService: MessageService,
              private localStorage: LocalStorageService,
              private adduserfirebaseService: AddUserFirebaseService,
              private noticeboardService: NoticeboardService,
              private departmentService: DepartmentService,
              public menuItems: MenuItems) {
    this.adduserModel.Username = '';
    this.adduserModel.Password = '';
    this.adduserModel.UserId = this.localStorage.retrieve('Id');
    this.adduserModel.BranchId = this.localStorage.retrieve('BranchId');
    // this.adduserModel.Code = this.localStorage.retrieve('Code');
    // this.adduserModel.Gender = this.localStorage.retrieve('GenderId');
    // this.adduserModel.Middlename = this.localStorage.retrieve('Middlename');
    // this.adduserModel.Enddate = this.localStorage.retrieve('Enddate');
    this.adduserModel.Statusid = this.localStorage.retrieve('Statusid');
    this.adduserModel.Profilephoto = this.localStorage.retrieve('Profilephoto');
    this.schoolid = this.localStorage.retrieve('SchoolId');
    this.allMenu = this.menuItems.getAll();
    this.allMenu[0].main.forEach(ele => {
      ele.selected = false;
    })

  }
  ngOnInit() {
    this.activateroute.params.subscribe(params => {
      this.userId = params['userId'];
    });
    this.getClassSection();

  };
  //schoolAdmin postData
  public schooladmin = [{
    StandardId: null,
    SectionId: null,
    SchoolId: this.localStorage.retrieve('SchoolId'),
    UserSpecializationCategoryId: ''
  }]
  //get departmentlist
  public getDepartments() {
    var pagenum;
    var searchString;
    this.departmentService.GetCategory(pagenum, searchString, this.islist).finally(() => { }).subscribe((response: any) => {
      this.categeories = response['items'];
      console.log( this.categeories)
      this.adminflag = this.categeories.some(ele => ele.SelectionType == 1);
      this.categeoriesList = this.categeories.filter(ele => ele.SelectionType !== 1)
      this.categeoriesList = this.categeoriesList.map(e => {
        let tabInnerContent = [];
        // console.log(tabInnerContent,'tabInnerContent');
        if (e.SelectionType == 2) {
          tabInnerContent = _.cloneDeep(this.SectionData);
        }
        if (e.SelectionType == 3) {
          tabInnerContent = _.cloneDeep(this.standards);
        }
        if (e.SelectionType == 4) {
          tabInnerContent = _.cloneDeep(this.mappedData);
        }
        if (e.SelectionType == 1) {
          tabInnerContent = [];
        }
        return {
          ...e,
          tabInnerContent
        }

      });

      this.selectedTabId = this.categeoriesList && this.categeoriesList[0] ? this.categeoriesList[0].Id : '';
      this.activetab = 0;
      this.UserSpecializationCategoryId = this.categeoriesList[0].Id;
      if (this.userId) {
        this.getUser(this.userId);
      }
    })

  }

  AssignGender(event){
    console.log(event.target.value)

    this.GenderId= Number(event.target.value);

  }



  //onSelection of tab
  selectedTab(tab, i) {
    this.selectedTabId = tab.Id;
    this.selectedtab = tab.SelectionType;
    this.activetab = i;
    this.UserSpecializationCategoryId = tab.Id;
  }
  //onSelection of permssions
  selectPermision(e, permission) {
    if (e.target.checked) {
      this.selectedPermission.push(permission)
    }
    else {
      this.selectedPermission = this.selectedPermission.filter(ele => ele.id != permission.id)
    }
  }
  //sectionHead tab selection
  sectionHead(e, section) {
    this.show = false;
    // this.tabroleID = classsection.RoleId;
    if (e.target.checked) {
      section.UserSpecializationCategoryId = this.UserSpecializationCategoryId;
      this.selectedClass.push(section);
    }
    else {
      this.selectedClass = this.selectedClass.filter(ele => ele.SectionId != section.SectionId);
    }
  }
  // gradeHead tab selection
  gradeHead(e, grade) {
    this.show = false;
    // this.tabroleID = grade.RoleId;
    if (e.target.checked) {
      grade.UserSpecializationCategoryId = this.UserSpecializationCategoryId;
      this.selectedClass.push(grade);
    }
    else {
      this.selectedClass = this.selectedClass.filter(ele => ele.StandardId != grade.StandardId)
    }
  }
  // sectionHead tab selection
  sectionalHead(e, section) {
    this.show = false;
    // let sectionalGradeId = section.SelectedGrades[0].SectionalGradeId;
    let sectionalGradeId =  section.SelectedGrades.length != 0?section.SelectedGrades[0].SectionalGradeId: []
    // this.tabroleID = section.RoleId;
    if (e.target.checked) {
      var sections = section['SelectedGrades'];
      var selectedsection = sections.map(o => {
        return {
          StandardId: o.StandardId,
          // RoleId: section.RoleId,
          SchoolId: section.SchoolId,
          SectionalGradeId: o.SectionalGradeId,
          UserSpecializationCategoryId: this.UserSpecializationCategoryId
        };
      });
      this.selectedClass = this.selectedClass.concat(selectedsection);
      console.log("after push", this.selectedClass)
      // selectedsection.forEach(ele => this.selectedClass.push(ele));
    }
    else {
      // this.selectedClass = this.selectedClass.filter(i => section['SelectedGrades'].indexOf(i) !== -1);
      this.selectedClass = this.selectedClass.filter(i => i.SectionalGradeId !== sectionalGradeId);
    }
  }
  //get departments
  public GetDepartments(pagenum) {
    this.departmentService.GetCategory(pagenum, '', this.islist).finally(() => { }).subscribe(
      response => {
        this.department = response['items'];
      }
    )
  }

  //getting sections for sectionalHead
  public getSections() {
    this.pagenum=1;
    this.SectionService.getSections(this.pagenum,this.searchString).finally(() => { }).subscribe(response => {
      this.SectionData = response['items'];
      console.log(this.SectionData, 'SectionData')
      // this.sectionsData = this.Data.map((item, index) => {
      // item.RoleId = "CFAA3C85-D6B0-4A13-A7C3-BCC306ADABBD";
      // return item;
      // });
      this.getDepartments();
    })
  }
  //main mappedData
  private getClassSection() {
    this.noticeboardService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        this.mappedData = response;
        //gradeHead data
        this.standards = this.mappedData.map(o => {
          return {
            standardsName: o.standardsName,
            standardId: o.standardId,
            StandardsName: o.standardsName,
            StandardId: o.standardId,
            // RoleId: '',
            SchoolId: this.schoolid
          };
        });
        //sectionHead data
        this.mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['standardId'] = standard['standardId'];
            section['StandardId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
            // section['RoleId'] = "";
            section['SchoolId'] = this.schoolid;
          });
        });
        this.getSections();
      },
      error => {
      });
  };
  goBack() {
    this.router.navigate(['parent/user'])
  }
  //post
  saveUser() {
    // this.addUserFirebaseModel['selectedPermission'] = this.selectedPermission;
    // this.addUserFirebaseModel['selectedClass'] = this.selectedClass;
    this.adduserModel['selectedPermission'] = this.selectedPermission;
    this.adduserModel['selectedClass'] = this.selectedClass;
    this.adduserModel['SchoolId'] = this.localStorage.retrieve('SchoolId');
    this.adduserModel['Gender']= this.GenderId;
    console.log(this.adduserModel)
    // this.adduserModel['IsSchoolAdminUser']=this.localStorage.retrieve('IsSchoolAdminUser');
    if (!this.entireSchoolflag) {
      if (this.selectedClass.length > 0 && this.selectedPermission.length > 0) {
        this.addUserService.postUser(this.adduserModel).finally(() => { }).subscribe(
          response => {

            var userId = response;
            // console.log('res',response);
            // this.addUserFirebaseModel['selectedCategory'] = this.selectedCategory;
            this.adduserModel['selectedClass'] = this.selectedClass;
            this.adduserModel['selectedPermission'] = this.selectedPermission;
            this.adduserModel['selectedCategory'] = this.selectedCategory;
            // this.adduserfirebaseService.postUser(this.addUserFirebaseModel, userId);
            this.adduserModel.IsSchoolAdminUser = false;
            this.router.navigate(['manageuser/manage-user']);
          },
          error => {
            this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: error.Message });
          });
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: 'Select atleast one class one menu permission' });
      }
    }
    else if (this.selectedPermission.length > 0 && this.entireSchoolflag) {
      this.adduserModel['selectedClass'] = [];
      this.adduserModel['selectedClass'] = this.schooladmin;
      this.adduserModel['selectedPermission'] = this.selectedPermission;
      this.adduserModel['selectedCategory'] = this.selectedCategory;
      this.adduserModel.IsSchoolAdminUser = true;
      console.log(this.adduserModel)
      this.addUserService.postUser(this.adduserModel).finally(() => { }).subscribe(
        response => {
          console.log(response)
          var userId = response;
          // this.adduserfirebaseService.postUser(this.addUserFirebaseModel, userId);
          this.router.navigate(['manageuser/manage-user']);
        },
        error => {
          this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: error.Message });
        });
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: 'Select atleast  one class or entire school' });
    }
  }
  //edit part
  public getUser(userId) {
    setTimeout(() => {
      this.addUserService.getUserdetailbyId(userId).subscribe(
        items => {
          console.log(items)
          this.selectedPayload = items;
          if (!this.selectedPayload['selectedClass']) {
            this.entireSchoolflag = true;
            this.adduserModel.IsSchoolAdminUser = true;
            // this.addUserFirebaseModel.IsSchoolAdminUser = true;
            this.Es = true;
          }
          this.allMenu[0]['main'].forEach(e => {
            if (this.selectedPayload['selectedClass'].filter(w => w.id == e.id).length > 0) {
              e.selected = true;
            } else {
              e.selected = false;
            }
            this.selectedPermission = this.selectedPayload['selectedClass'];
          });
          this.getuserDetailsbyId(userId);
        });
    }, 1500);
  }
  public getuserDetailsbyId(userId) {
    if (userId) {
      this.username = true;
    }
    this.addUserService.getUserdetailbyId(userId).finally(() => { }).subscribe(
      response => {
        // console.log(response)
        this.adduserModel = response;
        this.userdetailes = response['selectedSbAccessPermission'];
        this.userdetailes.forEach(el => {
          // console.log(el)
          this.selectedClass.push({
            SectionId: el.sectionid,
            StandardId: el.standardid,
            SchoolId: el.schoolid,
            SectionalGradeId: el.sectionalGradeId,
            UserSpecializationCategoryId: el.UserSpecializationCategoryId,
            schooluserid: el.schooluserid
            //all
          })
        })
        this.userdetailes.forEach(ud => {
          // console.log(ud)
          if (ud.Rank !== 1) {
            this.selectItemInList(ud.standardid,ud.sectionalGradeId, ud.Rank, ud.sectionid)
          } else if (ud.Rank == 1) {
            this.adminCheck(ud.Rank);
          }
        })
      },
      error => {
      });
  }
  //ADMIN CHECKBOX CHECKED
  public adminCheck(type) {
    if (type == 1) {
      this.Es = true;
      this.isDisabled = true;

    }
  }
  public selectItemInList(standardId,sectionalGradeId, type, sectionId) {
    this.categeoriesList.forEach(c => {
      // console.log(c)
      c.tabInnerContent.forEach(tc => {
        // console.log(tc)
        if (type === 2 && tc.SelectedGrades) {
          tc.SelectedGrades.forEach(sg => {
            // console.log(sg)
            if (sg.SectionalGradeId === sectionalGradeId) {
              tc.selected = true;
            }
          })
        } else if (type === 3) {
          if (tc.standardId === standardId) {
            tc.selected = true;
          }
        } else if (type === 4 && tc.Sections) {
          tc.Sections.forEach(s => {
            if (s.SectionId === sectionId) {
              s.selected = true;
            }
          })
        }

      })
    })
  }

  //EntireSchool selection(schoolAdmin)
  public entireSchool(e) {
    this.categeories.filter(ele => {
      if (ele.SelectionType == 1) {
        this.schooladmin[0].UserSpecializationCategoryId = ele.Id;
      }
    })
    if (e.target.checked) {
      this.isDisabled = true;
      this.entireSchoolflag = true;
      this.adduserModel.IsSchoolAdminUser = true;
      // this.addUserFirebaseModel.IsSchoolAdminUser = true;
      this.show = true;
      this.mappedData.forEach(element => {
        if (Array.isArray(element['Sections'])) {
          element['Sections'].forEach(e => {
            e['selected'] = false;
          });
        }
      });
      this.standards1.forEach(e => {
        e['selected'] = false;
      });
      this.standards.forEach(e => {
        e['selected'] = false;
      })
    }
    else {
      this.isDisabled = false;
      this.entireSchoolflag = false;
      this.adduserModel.IsSchoolAdminUser = false;

    }
  }


}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/manage-user/manage-add-user/manage-add-user.component.ts